export const visaTypes={
 tourist:'سياحية',business:'أعمال',work:'عمل',visit:'زيارة',
 family_visit:'زيارة عائلية',personal_visit:'زيارة شخصية',business_visit:'زيارة أعمال',
 transit:'عبور',umrah:'عمرة',hajj:'حج',student:'دراسة',medical:'علاج'
};
